export default __webpack_public_path__ + "static/media/Banner - AirDockz - Cobalt Blue.94ff1c65.jpg";